import { BroadsiderFooter, Missions, MissionsPage } from "../components"


export default function MissionsRoute() {
  return (
    <MissionsPage>
      <div className='menu-placeholder'/>
      <div style={{"display": "flex", "flexDirection": "column"}}>
        <Missions />
        <BroadsiderFooter/>
      </div>
    </MissionsPage>
  )
}
